import { Colors } from 'src/styles';
import styled, { css } from 'styled-components';

export const SelectToggle = styled.button<{
  error?: boolean;
  disabled?: boolean;
}>`
  appearance: none;
  outline: none;
  color: ${Colors.brand};
  border: none;
  background: inherit;
  margin: 0;
  padding: 0;

  ${({ error }) =>
    error &&
    css`
      border-color: ${Colors.error};
      background-color: ${Colors.errorLight};
      color: ${Colors.error};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      border-color: ${Colors.inactive};
      background: ${Colors.inactiveLighter};
      cursor: not-allowed;
      color: ${Colors.inactive};
    `};
`;
